var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#pattern0_108_84)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_108_84",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_108_84",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_108_84",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACBElEQVR4nO3dO07DUBSE4bMPanrCPsGHXUBByWNPCAmZQDsI0jkG3yhEnmP/I00VTXRvPkzKRJwiqfNI3Ueqj5QG7aPTXVzpLFyTxc8/cpnXkYsM+2J5qSx+/r3s/rLU2NtwSxY//17GH/Pf+hZuyeLn38vw0Ie+Pneqn39xF8ri51/chbL4+Rd3oXQ8/7UuI/Ucqe0BX3DjnbqQe4c5/j230enp5zM+AOPT+EIqDrJrp4+40WYaZPdk+F8oi4PsUB5aQI7/NwWIGkHeW0DqXCiLg4y9PyACpFSHAUSAUM0HDogAoQIkXAuIvAqIvAqIvAqIvAqIvAqIvEoIIYScLHN/yeXKCoi8Coi8Coi8Coi8Coi8Coi8Coi8Coi8Coi8Coi8CohWDtKaqrsExGsHiNkOELMdIGY7QMx2gJjtADHbAWK2A8RsVw6ECpAsVEDkVUC0cpDWVN0lIF47QMx2gJjtADHbAWK2A8RsB4jZDhCzHSBmu3IgVIBkoQIirwKilYO0puouAfHaAWK2A8RsB4jZDhCzHSBmO0DMdoCY7QAx25UDoQIkCxUQeRUQeRUQeRUQeRUQeRUQeRUQeRUQeRUQeRUQlQP53x+4p/qj/TRIpyeDg2oV7fQwDXKty+j0Mfthc+H9/ow7XURTbrSJ1GN0ep/94Lm49j9PRjMGIYQQEk35AmDo9fbcdwiuAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActive);
export default __webpack_public_path__ + "static/media/Calendar-active.c9b9d337e3811fb19f3207da338d0b24.svg";
export { ForwardRef as ReactComponent };